/** Public-only history. Private assistant/creation messages never enter this model. */
export function createActivityView({limit=100}={}) {
  let worldId=null,events=[],epoch=null,through=0;
  return {
    reset(id){if(worldId!==id){worldId=id;events=[];epoch=null;through=0;}},
    apply(message){
      if(message.worldId!==worldId)return false;
      if(message.type==='activityHistory'){
        if(epoch===message.epoch&&message.throughSequence<through)return false;
        epoch=message.epoch;through=message.throughSequence;events=[...new Map(message.events.filter(e=>e.worldId===worldId).map(e=>[e.id,e])).values()].sort((a,b)=>a.sequence-b.sequence).slice(-limit);return true;
      }
      const e=message.event;if(message.type!=='activity'||!e||e.worldId!==worldId||events.some(old=>old.id===e.id)||e.sequence<=through)return false;
      through=e.sequence;events.push(e);events=events.slice(-limit);return true;
    },
    entries(){return [...events];},
  };
}
export function activityText(event){const name=event.actor.name+(event.actor.kind==='npc'?' · AI resident':typeof event.actor.username==='string'&&/^[a-z][a-z0-9_]{2,23}$/.test(event.actor.username)?' @'+event.actor.username:'');return event.kind==='chat'||event.kind==='npc-chat'?`${name}: ${event.text}`:`${name} ${event.text}`;}
